/**
 * Lazy-loads jQuery + LightGallery for grid-image-lookbook sections on first interaction.
 * Asset URLs are set via window.__lookbookGalleryConfig from the section Liquid file.
 */
(function () {
  if (window.__lookbookGalleryBound) return;
  window.__lookbookGalleryBound = true;

  const assets = window.__lookbookGalleryConfig;
  if (!assets) return;

  const initialized = new WeakSet();
  const loading = new WeakSet();
  let assetsPromise = null;

  function loadStylesheet(href) {
    if (document.querySelector('link[href="' + href + '"]')) {
      return Promise.resolve();
    }

    return new Promise(function (resolve, reject) {
      const link = document.createElement("link");
      link.rel = "stylesheet";
      link.href = href;
      link.onload = resolve;
      link.onerror = reject;
      document.head.appendChild(link);
    });
  }

  function loadScript(src) {
    if (document.querySelector('script[src="' + src + '"]')) {
      return Promise.resolve();
    }

    return new Promise(function (resolve, reject) {
      const script = document.createElement("script");
      script.src = src;
      script.onload = resolve;
      script.onerror = reject;
      document.head.appendChild(script);
    });
  }

  function loadAssets() {
    if (!assetsPromise) {
      assetsPromise = loadStylesheet(assets.css)
        .then(function () {
          return loadScript(assets.jquery);
        })
        .then(function () {
          return loadScript(assets.lightgallery);
        });
    }

    return assetsPromise;
  }

  function setLoadingState(container, isLoading) {
    container.classList.toggle("is-lookbook-gallery-loading", isLoading);
    container.setAttribute(
      "aria-busy",
      isLoading ? "true" : "false"
    );
  }

  function initGallery(container, link) {
    const $ = window.jQuery;

    $(container).lightGallery({
      thumbnail: false,
      fullScreen: false,
      zoom: false,
      download: false,
      showAll: true,
      autoplayControls: false,
      share: false,
      swipeThreshold: 50,
      mode: "lg-fade",
      counter: false,
    });

    initialized.add(container);
    loading.delete(container);
    setLoadingState(container, false);
    $(link).trigger("click");
  }

  document.addEventListener(
    "click",
    function (event) {
      const link = event.target.closest("[data-lookbook-gallery] a[data-gall]");
      if (!link) return;

      const container = link.closest("[data-lookbook-gallery]");
      if (initialized.has(container)) return;

      event.preventDefault();

      if (loading.has(container)) return;

      loading.add(container);
      setLoadingState(container, true);

      loadAssets()
        .then(function () {
          initGallery(container, link);
        })
        .catch(function () {
          loading.delete(container);
          setLoadingState(container, false);
          window.location.href = link.href;
        });
    },
    true
  );
})();
